module.exports = __webpack_public_path__ + "img/3@2x.d0c42154.png";